import { render } from "./MessageChat.vue?vue&type=template&id=99830770"
const script = {}

import "./MessageChat.vue?vue&type=style&index=0&id=99830770&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__